export enum DeliveryMoment {
  Morning = 0,
  Afternoon = 1,
  Wholeday = 2,
  Evening = 3,
}

const DELIVERY_MOMENT_VALUES = Object.values(DeliveryMoment).filter(
  (value): value is number => typeof value === 'number'
);

export function asDeliveryMoment(value: number | string | undefined): DeliveryMoment | null {
  if (value === '' || value === undefined) {
    return null;
  }

  if (typeof value !== 'number') {
    value = Number(value);
  }

  if (isNaN(value) || !DELIVERY_MOMENT_VALUES.includes(value)) {
    return null;
  }

  return value;
}
